module.exports = __webpack_public_path__ + "img/2.e54268ea.png";